import _ from 'lodash'
import { MACMILLAN_API } from '../middleware/macmillan'
import { ANALYTICS_MIDDLEWARE_KEY } from '../middleware/analytics'
import { TIMING_MIDDLEWARE_KEY } from '../middleware/timing'
import getActivity from './getActivity'
import saveProgress from './saveProgress'
import getProgress from './getProgress'
import getActivityCompletionTime from './getActivityCompletionTime'
import getStudentRoster from './getStudentRoster'
import postAssignment from './postAssignment'
// import postCoachOffer from './postCoachOffer'
import postCoachSignup from './postCoachSignup'
import postChallenge from './postChallenge'
import { isLcrpAvailable } from '../lib/macmillan'
import { extractLoId } from '../../lcrp/lib/helpers'
import eventingHelper from './eventingHelper'
import { CHALLENGE_EMAIL_STEP } from '../components/ChallengeQuestionModal'
import { checkNetworkStatus } from './checkNetworkStatus'

export const INIT_ASSIGNMENT_REQUEST = 'INIT_ASSIGNMENT_REQUEST'
export const INIT_ASSIGNMENT_SUCCESS = 'INIT_ASSIGNMENT_SUCCESS'
export const INIT_ASSIGNMENT_FAILURE = 'INIT_ASSIGNMENT_FAILURE'

export const SAVE_PROGRESS_REQUEST = 'SAVE_PROGRESS_REQUEST'
export const SAVE_PROGRESS_SUCCESS = 'SAVE_PROGRESS_SUCCESS'
export const SAVE_PROGRESS_FAILURE = 'SAVE_PROGRESS_FAILURE'

export const LOAD_PROGRESS_REQUEST = 'LOAD_PROGRESS_REQUEST'
export const LOAD_PROGRESS_SUCCESS = 'LOAD_PROGRESS_SUCCESS'
export const LOAD_PROGRESS_FAILURE = 'LOAD_PROGRESS_FAILURE'

export const LOAD_ACTIVITY_COMPLETION_TIME_REQUEST = 'LOAD_ACTIVITY_COMPLETION_TIME_REQUEST'
export const LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS = 'LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS'
export const LOAD_ACTIVITY_COMPLETION_TIME_FAILURE = 'LOAD_ACTIVITY_COMPLETION_TIME_FAILURE'

export const LOAD_MACMILLAN_REQUEST = 'LOAD_MACMILLAN_REQUEST'
export const LOAD_MACMILLAN_SUCCESS = 'LOAD_MACMILLAN_SUCCESS'
export const LOAD_MACMILLAN_FAILURE = 'LOAD_MACMILLAN_FAILURE'

export const ACTIVITY_REQUEST = 'ACTIVITY_REQUEST'
export const ACTIVITY_SUCCESS = 'ACTIVITY_SUCCESS'
export const ACTIVITY_FAILURE = 'ACTIVITY_FAILURE'

export const COACH_OFFER_REQUEST = 'COACH_OFFER_REQUEST'
export const COACH_OFFER_SUCCESS = 'COACH_OFFER_SUCCESS'
export const COACH_OFFER_FAILURE = 'COACH_OFFER_FAILURE'

export const COACH_SIGNUP_REQUEST = 'COACH_SIGNUP_REQUEST'
export const COACH_SIGNUP_SUCCESS = 'COACH_SIGNUP_SUCCESS'
export const COACH_SIGNUP_FAILURE = 'COACH_SIGNUP_FAILURE'

export const CHALLENGE_REQUEST = 'CHALLENGE_REQUEST'
export const CHALLENGE_SUCCESS = 'CHALLENGE_SUCCESS'
export const CHALLENGE_FAILURE = 'CHALLENGE_FAILURE'

export const LOAD_STUDENT_ROSTER_REQUEST = 'LOAD_STUDENT_ROSTER_REQUEST'
export const LOAD_STUDENT_ROSTER_SUCCESS = 'LOAD_STUDENT_ROSTER_SUCCESS'
export const LOAD_STUDENT_ROSTER_FAILURE = 'LOAD_STUDENT_ROSTER_FAILURE'

export const QUESTION_EVENT = 'QUESTION_EVENT'

function loadMacmillan () {
  return {
    [MACMILLAN_API]: {
      types: [
        LOAD_MACMILLAN_REQUEST,
        LOAD_MACMILLAN_SUCCESS,
        LOAD_MACMILLAN_FAILURE
      ]
    }
  }
}

export function loadPreload () {
  return (dispatch) => dispatch(loadMacmillan())
}

export function loadActivity (activityFile) {
  return (dispatch, getState) => {
    const { ACTIVITY_HOSTNAME, ACTIVITY_BASE_PATH, DEFAULT_ACTIVITY_FILE } = getState().core.config
    const activityHostname = ACTIVITY_HOSTNAME || ''
    const activityBasePath = ACTIVITY_BASE_PATH || 'learningcurve_activity_config/'
    const endpoint = activityHostname + activityBasePath + (activityFile || DEFAULT_ACTIVITY_FILE) + '.txt'
    return dispatch(getActivity(endpoint, getState().core.initialUserData))
  }
}

export function initAssignment (payload) {
  return (dispatch) => dispatch(postAssignment(payload))
}

export function loadProgress (payload) {
  return (dispatch) => dispatch(getProgress(payload))
}

export function loadActivityCompletionTime (payload) {
  return (dispatch) => dispatch(getActivityCompletionTime(payload))
}

export function loadStudentRoster (payload) {
  return (dispatch) => dispatch(getStudentRoster(payload))
}

export const SAVE_ATTEMPT = 'SAVE_ATTEMPT'

// LST-1258: Revert part of RNI-1245
export function saveAttempt (payload, fqUid) {
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_ATTEMPT,
      payload,
      [TIMING_MIDDLEWARE_KEY]: true
    })

    const core = getState().core
    const activity = core.activity
    const uiState = core.uiState

    /*
    if (!getState().coach.offered &&
      activity.score.activityScore >= activity.score.scoreTarget &&
      !activity.config.isInstructorView) {
      dispatch(postCoachOffer())
    }
*/
    if (uiState.isIncorrectModalDisplayed) {
      return dispatch(logIncorrectAttempt(fqUid, payload, activity.score.curCard.questionType, activity.studentData))
    } else if (uiState.isSuccessModalDisplayed) {
      return dispatch(logCorrectAttempt(fqUid, payload, activity.score.curCard.questionType, activity.studentData))
    }
  }
}

export const SHOW_ANSWER = 'SHOW_ANSWER'
export function showAnswer (payload, fqUid) {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: SHOW_ANSWER,
      payload,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Show Answer',
          label: fqUid,
          data: {
            fqUid,
            actTitle: activity.activityTitle,
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic'
          }
        }]],
      [TIMING_MIDDLEWARE_KEY]: true
    })
    saveProgress(activity, dispatch, getState)
    if (activity.config.isInstructorView !== true || !activity.config.simulateData) {
      dispatch({
        type: QUESTION_EVENT,
        [TIMING_MIDDLEWARE_KEY]: true,
        [ANALYTICS_MIDDLEWARE_KEY]: [
          'event',
          [
            {
              category: 'LCRP',
              action: 'Start/Complete Question',
              label: _.get(activity.config.toolInfo, 'uuid', 'none'),
              data: {
                userData: activity.studentData,
                lc_uuid: _.get(activity.config.toolInfo, 'uuid', 'none'),
                actEndp: activity.config.file + '.txt',
                user_id: activity.studentData.user_id,
                fq_uid: activity.score.curCard.meta.fq_uid,
                loId: extractLoId(activity.score.curCard.meta),
                assignmentId: activity.studentData.assignment_id,
                question_action: 'completed'
              }
            }
          ]
        ]
      })
    }
  }
}

export const NEXT_ITEM = 'NEXT_ITEM'
export function nextItem (fqUid) {
  return (dispatch, getState) => {
    let activity = getState().core.activity
    const assignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate
    dispatch({
      type: NEXT_ITEM,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Next Item Clicked',
          label: fqUid,
          data: {
            userData: activity.studentData,
            beforeNextFqUid: fqUid,
            question: activity.score.curCard &&
        activity.score.curCard.questionText
              ? activity.score.curCard.questionText
              : '',
            attemptNumber: activity.score.curCard &&
        activity.score.curCard.answered.length
              ? activity.score.curCard.answered.length
              : '',
            topic: activity.score.curCard &&
        activity.score.curCard.topic.label
              ? activity.score.curCard.topic.label
              : '',
            blooms: activity.score.curCard &&
        activity.score.curCard.meta.blooms
              ? activity.score.curCard.meta.blooms
              : '',
            webbs_depth_of_knowledge: activity.score.curCard && activity.score.curCard.meta.webbs_depth_of_knowledge
              ? activity.score.curCard.meta.webbs_depth_of_knowledge
              : '',
            sme_difficulty: activity.score.curCard &&
        activity.score.curCard.meta.level
              ? activity.score.curCard.meta.level
              : '',
            actTitle: activity.activityTitle,
            dueDate: assignmentDate,
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic',
            learning_objective: activity.score.curCard &&
        activity.score.curCard.meta.learning_objectives
              ? activity.score.curCard.meta.learning_objectives
              : '',
            selectionTimeUTC: new Date().getTime()
          }
        }]],
      [TIMING_MIDDLEWARE_KEY]: true
    })
    // get a new activity for saving
    activity = getState().core.activity
    const core = getState().core
    const extractedLoId = extractLoId(activity.score.curCard.meta)
    core.extractedLoId = extractedLoId

    // we're saving progress after every 'next item' in order to properly increment the student's questions received
    // this is inline with the number of persistence calls LaunchPad performs for the same purpose so this most likely
    // won't be a massive burden
    saveProgress(activity, dispatch, getState)

    eventingHelper(core, 'NEXT_ITEM')

    // only dispatch if a student taking a quiz, not for instructors or preview mode
    if (activity.config.isInstructorView !== true || !activity.config.simulateData) {
      dispatch({
        type: QUESTION_EVENT,
        [TIMING_MIDDLEWARE_KEY]: true,
        [ANALYTICS_MIDDLEWARE_KEY]: [
          'event',
          [
            {
              category: 'LCRP',
              action: 'Start/Complete Question',
              label: _.get(activity.config.toolInfo, 'uuid', 'none'),
              data: {
                userData: activity.studentData,
                lc_uuid: _.get(activity.config.toolInfo, 'uuid', 'none'),
                actEndp: activity.config.file + '.txt',
                user_id: activity.studentData.user_id,
                fq_uid: activity.score.curCard.meta.fq_uid,
                loId: extractLoId(activity.score.curCard.meta),
                assignmentId: activity.studentData.assignment_id,
                question_action: 'started'
              }
            }
          ]
        ]
      })
    }
  }
}

export const PAUSE_ACTIVITY = 'PAUSE_ACTIVITY'
export function pauseActivity () {
  return async (dispatch, getState) => {
    const activity = getState().core.activity
    await dispatch({
      type: PAUSE_ACTIVITY,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Activity Paused',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
          data: {
            userData: activity.studentData,
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
            actTitle: activity.activityTitle,
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic'
          }
        }]]
    })
    await saveProgress(activity, dispatch, getState)
  }
}

export const RESUME_ACTIVITY = 'RESUME_ACTIVITY'
export function resumeActivity () {
  return (dispatch, getState) => {
    let activity = getState().core.activity

    /* given the number of activities associated with 'resuming' an activity, which is actually an event that is
    fired upon activity start, we need to differentiate if this is the 'start' for analytics */
    let isResume = false // if false, it is the activity start

    for (let i = 0; i < activity.allTopics.length; i++) {
      if (isResume === false) {
        isResume = activity.allTopics[i].questionsReceived > 0
      }
    }
    const assignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate || ''
    dispatch({
      type: RESUME_ACTIVITY,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Activity Resumed',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
          data: {
            userData: activity.studentData,
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
            isResume,
            actTitle: activity.activityTitle,
            question: activity.score.curCard ? activity.score.curCard.questionText : '',
            questionType: activity.score.curCard ? activity.score.curCard.questionType : '',
            attemptNumber: activity.score.curCard ? activity.score.curCard.answered.length : '',
            topic: activity.score.curCard ? activity.score.curCard.topic.label : '',
            blooms: activity.score.curCard ? activity.score.curCard.meta.blooms : '',
            webbs_depth_of_knowledge: activity.score.curCard && activity.score.curCard.meta.webbs_depth_of_knowledge
              ? activity.score.curCard.meta.webbs_depth_of_knowledge
              : '',
            sme_difficulty: activity.score.curCard ? activity.score.curCard.meta.level : '',
            dueDate: assignmentDate,
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic',
            learning_objective: activity.score.curCard &&
        activity.score.curCard.meta.learning_objectives
              ? activity.score.curCard.meta.learning_objectives
              : '',
            selectionTimeUTC: new Date().getTime()
          }
        }]],
      [TIMING_MIDDLEWARE_KEY]: true
    })

    // get a new activity for saving
    activity = getState().core.activity
    const core = getState().core
    const extractedLoId = extractLoId(activity.score.curCard.meta)
    core.extractedLoId = extractedLoId

    if (activity.config.isInstructorView !== true || !activity.config.simulateData) {
      dispatch({
        type: QUESTION_EVENT,
        [TIMING_MIDDLEWARE_KEY]: true,
        [ANALYTICS_MIDDLEWARE_KEY]: [
          'event',
          [
            {
              category: 'LCRP',
              action: 'Start/Complete Question',
              label: _.get(activity.config.toolInfo, 'uuid', 'none'),
              data: {
                userData: activity.studentData,
                lc_uuid: _.get(activity.config.toolInfo, 'uuid', 'none'),
                actEndp: activity.config.file + '.txt',
                user_id: activity.studentData.user_id,
                fq_uid: activity.score.curCard.meta.fq_uid,
                loId: extractLoId(activity.score.curCard.meta),
                assignmentId: activity.studentData.assignment_id,
                question_action: 'started'
              }
            }
          ]
        ]
      })
    }

    // we're saving progress after every 'resume' in order to properly increment the student's questions received
    // this is inline with the number of persistence calls LaunchPad performs for the same purpose so this most likely
    // won't be a massive burden
    saveProgress(activity, dispatch, getState)
    eventingHelper(core, 'RESUME_ACTIVITY')
  }
}

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE'
export function resetErrorMessage () {
  return {
    type: RESET_ERROR_MESSAGE
  }
}

export const SHOW_EBOOK = 'SHOW_EBOOK'
export function showEbook (fqUid, isLegacyEbook, ebookString) {
  return (dispatch, getState) => {
    const activity = getState().core.activity

    dispatch({
      type: SHOW_EBOOK,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Read Ebook',
          label: fqUid,
          data: {
            userData: activity.studentData,
            fqUid,
            ebookString,
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
            actTitle: activity.activityTitle,
            topic: activity.score.curCard &&
        activity.score.curCard.topic.label
              ? activity.score.curCard.topic.label
              : '',
            sme_difficulty: activity.score.curCard &&
        activity.score.curCard.meta.level
              ? activity.score.curCard.meta.level
              : '',
            blooms: activity.score.curCard &&
        activity.score.curCard.meta.blooms
              ? activity.score.curCard.meta.blooms
              : '',
            webbs_depth_of_knowledge: activity.score.curCard && activity.score.curCard.meta.webbs_depth_of_knowledge
              ? activity.score.curCard.meta.webbs_depth_of_knowledge
              : '',
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic',
            description: 'A user has selected a reading while taking a quiz in ' +
          `${isLcrpAvailable() ? 'LCRP' : 'LC Classic'}`,
            userAction: 'DuringQuizReadingSelected',
            section: { ebookUrl: ebookString }
          }
        }]]
    })
  }
}

export const SHOW_PSP_EBOOK = 'SHOW_PSP_EBOOK'
export function showPspEbook (item) {
  return (dispatch, getState) => {
    const activity = getState().core.activity

    dispatch({
      type: SHOW_PSP_EBOOK,
      value: item,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Read PSP Ebook',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
          data: {
            userData: activity.studentData,
            ebookString: item.pageId,
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
            actTitle: activity.activityTitle,
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic',
            description: 'A user has selected a reading from their PSP in LC Classic.',
            userAction: 'ClassicLCPSPReading',
            topic: activity.score.curCard &&
        activity.score.curCard.topic.label
              ? activity.score.curCard.topic.label
              : '',
            sme_difficulty: activity.score.curCard &&
        activity.score.curCard.meta.level
              ? activity.score.curCard.meta.level
              : '',
            blooms: activity.score.curCard &&
        activity.score.curCard.meta.blooms
              ? activity.score.curCard.meta.blooms
              : '',
            webbs_depth_of_knowledge: activity.score.curCard && activity.score.curCard.meta.webbs_depth_of_knowledge
              ? activity.score.curCard.meta.webbs_depth_of_knowledge
              : '',
            section: { ebookUrl: item.pageId }
          }
        }]]
    })
  }
}

export const SHOW_SPLIT_SCREEN_EBOOK = 'SHOW_SPLIT_SCREEN_EBOOK'
export function showSplitScreenEbook (fqUid) {
  return {
    type: SHOW_SPLIT_SCREEN_EBOOK,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{
        category: 'Activity',
        action: 'Read Split Screen Ebook',
        label: fqUid,
        data: { fqUid }
      }]]
  }
}

export const SET_TARGET_SCORE = 'SET_TARGET_SCORE'
export function setTargetScore (targetScore) {
  return {
    type: SET_TARGET_SCORE,
    targetScore,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{
        category: 'Instructor',
        action: 'Set Target Score',
        data: { targetScore }
      }]]
  }
}

export const SET_ENABLED_TOPICS = 'SET_ENABLED_TOPICS'
export function setEnabledTopics (enabledTopics) {
  return {
    type: SET_ENABLED_TOPICS,
    enabledTopics,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'Instructor', action: 'Set Enabled Topics' }]]
  }
}

export const ABOUT_LEARNING_CURVE = 'ABOUT_LEARNING_CURVE'
export function aboutLearningCurve () {
  return {
    type: ABOUT_LEARNING_CURVE,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'Instructor', action: 'Read About LearningCurve' }]]
  }
}

export const VIEW_SAMPLE_RESULTS = 'VIEW_SAMPLE_RESULTS'
export function viewSampleResults () {
  return {
    type: VIEW_SAMPLE_RESULTS,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'Instructor', action: 'Utilized Sample Results' }]]
  }
}

export const VIEW_SAMPLE_LCRP_RESULTS = 'VIEW_SAMPLE_LCRP_RESULTS'
export function viewSampleLCRPResults () {
  return {
    type: VIEW_SAMPLE_LCRP_RESULTS,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'Instructor', action: 'Utilized Sample LCRP Results' }]]
  }
}

export const HIDE_SAMPLE_RESULTS = 'HIDE_SAMPLE_RESULTS'
export function hideSampleResults () {
  return {
    type: HIDE_SAMPLE_RESULTS
  }
}

export const VIEW_SAMPLE_TRENDS_DATA = 'VIEW_SAMPLE_TRENDS_DATA'
export function viewSampleTrendsData () {
  return {
    type: VIEW_SAMPLE_TRENDS_DATA
  }
}

export const HIDE_SAMPLE_TRENDS_DATA = 'HIDE_SAMPLE_TRENDS_DATA'
export function hideSampleTrendsData () {
  return {
    type: HIDE_SAMPLE_TRENDS_DATA
  }
}

export const SHOW_HINT = 'SHOW_HINT'
export function showHint (fqUid) {
  return (dispatch, getState) => {
    let activity = getState().core.activity
    dispatch({
      type: SHOW_HINT,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Show Hint',
          label: fqUid,
          data: {
            userData: activity.studentData,
            fqUid,
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : ''
          }
        }]]
    })
    activity = getState().core.activity
    saveProgress(activity, dispatch, getState)
  }
}

export const HIDE_HINT = 'HIDE_HINT'
export function hideHint () {
  return {
    type: HIDE_HINT
  }
}

export const CLOSE_MID_ACTIVITY_MODAL = 'CLOSE_MID_ACTIVITY_MODAL'
export function closeMidActivityModal () {
  return {
    type: CLOSE_MID_ACTIVITY_MODAL
  }
}

export const CLOSE_COMPLETED_ACTIVITY_MODAL = 'CLOSE_COMPLETED_ACTIVITY_MODAL'
export function closeCompletedActivityModal () {
  return {
    type: CLOSE_COMPLETED_ACTIVITY_MODAL
  }
}

export const CLOSE_INCORRECT_MODAL = 'CLOSE_INCORRECT_MODAL'
export function closeIncorrectModal () {
  return {
    type: CLOSE_INCORRECT_MODAL
  }
}

export const CLOSE_SLOW_DOWN_MODAL = 'CLOSE_SLOW_DOWN_MODAL'
export function closeSlowDownModal () {
  return {
    type: CLOSE_SLOW_DOWN_MODAL
  }
}

export const CLOSE_SLOW_DEDUCT_MODAL = 'CLOSE_SLOW_DEDUCT_MODAL'
export function closeSlowDeductModal () {
  return {
    type: CLOSE_SLOW_DEDUCT_MODAL
  }
}

export const CLOSE_EBOOK_MODAL = 'CLOSE_EBOOK_MODAL'
export function closeEbookModal () {
  return {
    type: CLOSE_EBOOK_MODAL
  }
}

export const CLOSE_SPLIT_SCREEN_EBOOK_MODAL = 'CLOSE_SPLIT_SCREEN_EBOOK_MODAL'
export function closeSplitScreenEbookModal () {
  return {
    type: CLOSE_SPLIT_SCREEN_EBOOK_MODAL
  }
}

export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS'
export const updateNetworkStatus = () => {
  return async (dispatch, getState) => {
    await checkNetworkStatus(dispatch, getState);
  }
}

export const NETWORK_STATUS_UP = 'NETWORK_STATUS_UP';
export const networkStatusUp = () => {
  return (dispatch, getState) => {
    return dispatch({ type: NETWORK_STATUS_UP })
  }
}

export const NETWORK_STATUS_DOWN = 'NETWORK_STATUS_DOWN';
export const networkStatusDown = () => {
  return (dispatch, getState) => {
    return dispatch({ type: NETWORK_STATUS_DOWN })
  }
}

export const SHOW_NETWORK_ISSUE_MODAL = 'SHOW_NETWORK_ISSUE_MODAL'
export const showNetworkIssueModal = () => {
  return (dispatch, getState) => {
    return dispatch({ type: SHOW_NETWORK_ISSUE_MODAL })
  }
}

export const CLOSE_NETWORK_ISSUE_MODAL = 'CLOSE_NETWORK_ISSUE_MODAL'
export const closeNetworkIssueModal = () => {
  return (dispatch, getState) => {
    return dispatch({ type: CLOSE_NETWORK_ISSUE_MODAL })
  }
}

const LOG_CORRECT_ATTEMPT = 'LOG_CORRECT_ATTEMPT'
export function logCorrectAttempt (fqUid, answer, questionType, userData) {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    if (activity.studentData.activity_questions_correct === undefined) {
      activity.studentData.activity_questions_correct = 1
    } else {
      activity.studentData.activity_questions_correct++
    }
    const assignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate || ''

    dispatch({
      type: LOG_CORRECT_ATTEMPT,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Correct Attempt',
          label: fqUid,
          data: {
            userData,
            fqUid,
            question: activity.score.curCard.questionText,
            attemptNumber: activity.score.curCard.answered.length,
            topic: activity.score.curCard.topic.label,
            blooms: activity.score.curCard.meta.blooms ? activity.score.curCard.meta.blooms : '',
            webbs_depth_of_knowledge: activity.score.curCard && activity.score.curCard.meta.webbs_depth_of_knowledge
              ? activity.score.curCard.meta.webbs_depth_of_knowledge
              : '',
            sme_difficulty: activity.score.curCard ? activity.score.curCard.meta.level : '',
            answer,
            questionType,
            actTitle: activity.activityTitle,
            dueDate: assignmentDate,
            learning_objective: activity.score.curCard &&
        activity.score.curCard.meta.learning_objectives
              ? activity.score.curCard.meta.learning_objectives
              : '',
            selectionTimeUTC: new Date().getTime(),
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic'
          }
        }]]
    })

    saveProgress(activity, dispatch, getState)

    const core = getState().core
    const extractedLoId = extractLoId(activity.score.curCard.meta)
    core.extractedLoId = extractedLoId

    eventingHelper(core, 'LOG_CORRECT_ATTEMPT')

    if (activity.config.isInstructorView !== true || !activity.config.simulateData) {
      dispatch({
        type: QUESTION_EVENT,
        [TIMING_MIDDLEWARE_KEY]: true,
        [ANALYTICS_MIDDLEWARE_KEY]: [
          'event',
          [
            {
              category: 'LCRP',
              action: 'Start/Complete Question',
              label: _.get(activity.config.toolInfo, 'uuid', 'none'),
              data: {
                userData: activity.studentData,
                lc_uuid: _.get(activity.config.toolInfo, 'uuid', 'none'),
                actEndp: activity.config.file + '.txt',
                user_id: activity.studentData.user_id,
                fq_uid: activity.score.curCard.meta.fq_uid,
                loId: extractLoId(activity.score.curCard.meta),
                assignmentId: activity.studentData.assignment_id,
                question_action: 'completed'
              }
            }
          ]
        ]
      })
    }

    if (isLcrpAvailable()) {
      const firstAttemptComplete = require('../../lcrp/actions/index').firstAttemptComplete
      const additionalAttemptComplete = require('../../lcrp/actions/index').additionalAttemptComplete
      if (activity.score.activityScore >= activity.score.scoreTarget) {
        const dataObj = {
          uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          userData: activity.studentData,
          actTitle: activity.activityTitle,
          actEndp: activity.config.file + '.txt',
          user_id: activity.studentData.user_id,
          assignmentId: activity.studentData.assignmentId,
          activityType: 'LCRP',
          completedQuizTime: new Date().getTime()
        }
        if (activity.lcrp.progress.ra && activity.lcrp.progress.ra.length > 0) {
          dataObj.retakeNumber = activity.lcrp.progress.ra.length + 1
        }
        dispatch({
          type: 'REACH_SCORE_TARGET',
          [TIMING_MIDDLEWARE_KEY]: true,
          [ANALYTICS_MIDDLEWARE_KEY]: ['event',
            [{
              category: 'LCRP',
              action: 'Reach Score Target',
              label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
              data: dataObj
            }]]
        })
        if (activity.finalScore === null) {
          dispatch(firstAttemptComplete())
        } else {
          dispatch(additionalAttemptComplete())
        }
      }
    }
  }
}

const LOG_INCORRECT_ATTEMPT = 'LOG_INCORRECT_ATTEMPT'
export function logIncorrectAttempt (fqUid, answer, questionType, userData) {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const assignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate
    dispatch({
      type: LOG_INCORRECT_ATTEMPT,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Incorrect Attempt',
          label: fqUid,
          data: {
            userData,
            fqUid,
            question: activity.score.curCard.questionText,
            attemptNumber: activity.score.curCard.answered.length,
            topic: activity.score.curCard.topic.label,
            blooms: activity.score.curCard.meta.blooms ? activity.score.curCard.meta.blooms : '',
            webbs_depth_of_knowledge: activity.score.curCard && activity.score.curCard.meta.webbs_depth_of_knowledge
              ? activity.score.curCard.meta.webbs_depth_of_knowledge
              : '',
            sme_difficulty: activity.score.curCard ? activity.score.curCard.meta.level : '',
            answer,
            questionType,
            actTitle: activity.activityTitle,
            dueDate: assignmentDate,
            learning_objective: activity.score.curCard &&
        activity.score.curCard.meta.learning_objectives
              ? activity.score.curCard.meta.learning_objectives
              : '',
            activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic'
          }
        }]]
    })

    const core = getState().core
    const extractedLoId = extractLoId(activity.score.curCard.meta)
    core.extractedLoId = extractedLoId

    eventingHelper(core, 'LOG_INCORRECT_ATTEMPT')
  }
}

export const SHOW_SCORE_TOOLTIP = 'SHOW_SCORE_TOOLTIP'
export function showScoreTooltip () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: SHOW_SCORE_TOOLTIP,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Show Score Tooltip',
          data: { userData: activity.studentData }
        }]]
    })
  }
}

export const SHOW_QUESTION_TOOLTIP = 'SHOW_QUESTION_TOOLTIP'
export function showQuestionTooltip () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: SHOW_QUESTION_TOOLTIP,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Show Question Tooltip',
          data: { userData: activity.studentData }
        }]]
    })
  }
}

export const CHALLENGE_QUESTION_MODAL = 'CHALLENGE_QUESTION_MODAL'
export function challengeQuestionModal () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: CHALLENGE_QUESTION_MODAL,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Challenge Question Modal Opened',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
          data: {
            userData: activity.studentData,
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : ''
          }
        }]]
    })
  }
}

export const CLOSE_CHALLENGE_QUESTION_MODAL = 'CLOSE_CHALLENGE_QUESTION_MODAL'
export function closeChallengeQuestionModal () {
  return {
    type: CLOSE_CHALLENGE_QUESTION_MODAL
  }
}

export const CHANGE_CHALLENGE_VALUE = 'CHANGE_CHALLENGE_VALUE'
export function changeChallengeValue (value) {
  return {
    type: CHANGE_CHALLENGE_VALUE,
    value
  }
}

export const CHANGE_CHALLENGE_ISSUE_TYPE = 'CHANGE_CHALLENGE_ISSUE_TYPE'
export function changeChallengeIssueTypeValue (value) {
  return {
    type: CHANGE_CHALLENGE_ISSUE_TYPE,
    value
  }
}

export const CHANGE_CHALLENGE_EMAIL_VALUE = 'CHANGE_CHALLENGE_EMAIL_VALUE'
export function changeChallengeEmailValue (value) {
  return {
    type: CHANGE_CHALLENGE_EMAIL_VALUE,
    value
  }
}

export const CHALLENGE_INVALID_EMAIL = 'CHALLENGE_INVALID_EMAIL'
export function sendChallengeValue () {
  return (dispatch, getState) => {
    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}/
    const validEmail =
      !getState().core.uiState.challengeEmailValue ||
      getState().core.uiState.challengeEmailValue.length === 0 ||
      (getState().core.uiState.challengeEmailValue.length > 0 &&
      emailRegex.test(getState().core.uiState.challengeEmailValue))

    console.log(validEmail)
    if (validEmail) {
      dispatch(postChallenge())
    } else {
      dispatch({ type: CHALLENGE_INVALID_EMAIL })
    }
  }
}

export const NEXT_CHALLENGE_STEP = 'NEXT_CHALLENGE_STEP'
export const CHALLENGE_INVALID = 'CHALLENGE_INVALID'
export const CHALLENGE_INVALID_ISSUE_TYPE = 'CHALLENGE_INVALID_ISSUE_TYPE'
export function nextChallengeStep () {
  return (dispatch, getState) => {
    const validValue = getState().core.uiState.challengeQuestionValue.length >= 50 // Body of the challenge must be at least 50 characters long
    const validIssue = getState().core.uiState.challengeIssueTypeValue // Issue Type of the challenge must be selected

    if (validValue && validIssue) {
      dispatch({ type: NEXT_CHALLENGE_STEP, value: CHALLENGE_EMAIL_STEP })
    } else {
      if (!validIssue) dispatch({ type: CHALLENGE_INVALID_ISSUE_TYPE })
      if (!validValue) dispatch({ type: CHALLENGE_INVALID })
    }
  }
}

export const CLOSE_CHALLENGE_SENT_MODAL = 'CLOSE_CHALLENGE_SENT_MODAL'
export function closeChallengeSentModal () {
  return {
    type: CLOSE_CHALLENGE_SENT_MODAL
  }
}

export const CONTACT_TECH_SUPPORT = 'CONTACT_TECH_SUPPORT'
export function contactTechSupport () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: CONTACT_TECH_SUPPORT,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Contact Tech Support',
          data: { userData: activity.studentData, uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : '' }
        }]]
    })
  }
}

export const SHOW_COACH_SIGNUP_MODAL = 'SHOW_COACH_SIGNUP_MODAL'
export function showCoachSignupModal () {
  return {
    type: SHOW_COACH_SIGNUP_MODAL
  }
}

export const CLOSE_COACH_SIGNUP_MODAL = 'CLOSE_COACH_SIGNUP_MODAL'
export function closeCoachSignUpModal () {
  return {
    type: CLOSE_COACH_SIGNUP_MODAL
  }
}

export function saveCoachSignup (phone) {
  return (dispatch) => dispatch(postCoachSignup(phone))
}

export const FAQ = 'FAQ'
export function faq () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: FAQ,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Student',
          action: 'Frequently Asked Questions Viewed',
          data: { userData: activity.studentData }
        }]]
    })
  }
}

export const TIPS_FOR_SUCCESS = 'TIPS_FOR_SUCCESS'
export function tipsForSuccess () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: TIPS_FOR_SUCCESS,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'Activity',
          action: 'Tips for Success Viewed',
          data: { userData: activity.studentData }
        }]]
    })
  }
}

export const CLOSE_TIPS_FOR_SUCCESS = 'CLOSE_TIPS_FOR_SUCCESS'
export function closeTipsForSuccess () {
  return {
    type: CLOSE_TIPS_FOR_SUCCESS
  }
}

export const UPDATE_RADIO_BUTTONS = 'UPDATE_RADIO_BUTTONS'
export function updateRadioButtons (selection) {
  // DEV NOTE: Might want to move this whole function into the LCRP actions at a later date, as it looks LCRP only
  if (isLcrpAvailable()) {
    return (dispatch, getState) => {
      const activity = getState().core.activity
      dispatch({
        type: UPDATE_RADIO_BUTTONS,
        payload: selection,
        [TIMING_MIDDLEWARE_KEY]: true,
        [ANALYTICS_MIDDLEWARE_KEY]: ['event',
          [{
            category: 'LCRP',
            action: 'Instructor Update Radio Buttons',
            label: activity.config.toolInfo ? activity.config.toolInfo.uuid : '',
            data: {
              uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
              userData: activity.studentData,
              actTitle: activity.activityTitle,
              actEndp: activity.config.file + '.txt',
              user_id: activity.studentData.user_id,
              assignmentId: activity.studentData.assignmentId,
              activityType: 'LCRP',
              selectionTimeUTC: new Date().getTime()
            }
          }]]
      })
    }
  } else {
    return {
      type: UPDATE_RADIO_BUTTONS,
      payload: selection
    }
  }
}

export const creators = {
  loadPreload,
  loadActivity,
  loadProgress,
  loadStudentRoster,
  saveAttempt,
  showAnswer,
  nextItem,
  pauseActivity,
  resumeActivity,
  resetErrorMessage,
  showEbook,
  showPspEbook,
  showSplitScreenEbook,
  setTargetScore,
  setEnabledTopics,
  aboutLearningCurve,
  viewSampleResults,
  viewSampleLCRPResults,
  hideSampleResults,
  viewSampleTrendsData,
  hideSampleTrendsData,
  showHint,
  hideHint,
  closeMidActivityModal,
  closeCompletedActivityModal,
  closeIncorrectModal,
  closeSlowDownModal,
  closeSlowDeductModal,
  closeEbookModal,
  closeSplitScreenEbookModal,
  showNetworkIssueModal,
  closeNetworkIssueModal,
  logCorrectAttempt,
  logIncorrectAttempt,
  showScoreTooltip,
  showQuestionTooltip,
  challengeQuestionModal,
  closeChallengeQuestionModal,
  changeChallengeValue,
  changeChallengeIssueTypeValue,
  changeChallengeEmailValue,
  nextChallengeStep,
  sendChallengeValue,
  closeChallengeSentModal,
  contactTechSupport,
  showCoachSignupModal,
  closeCoachSignUpModal,
  saveCoachSignup,
  faq,
  tipsForSuccess,
  closeTipsForSuccess,
  updateNetworkStatus,
  updateRadioButtons
}
